/**
 * 八音盒
 */
import instance from '@/utils/axios';

/**
 * 设置场景
 * currScene: 1-公共场景|2-室内场景。
 * @param {{ sn: string, deviceType: string, currScene : 1|2}} data
 */
export function setScene(params) {
  return instance.get('/hwperipheral/sceneSetting', { params });
}

/**
 * 时间设置
 * @param {{ sn: string, deviceType: string, currTime : number}} data
 * @returns {Promise<any>}
 */
export function setTime(params) {
  return instance.get('/hwperipheral/timeSetting', { params });
}

/**
 * 获取设备状态
 * @param {{ sn: string, deviceType: string, busiType: 1|2|3 }} params
 * @returns {Promise<any>}
 */
export function getDeviceStatus(params) {
  return instance.get('/hwperipheral/deviceState', { params });
}

/**
 * 获取设备信息
 * @param {{ sn: string, deviceType: string}} params
 * @returns {Promise<any>}
 */
export function getDeviceInfo(params) {
  return instance.get('/hwperipheral/deviceInfo', { params });
}

/**
 * 参数设置
 * @param {{ sn: string, deviceType: string, requestData: any}} data
 * @returns {Promise<any>}
 */
export function paramSetting(data) {
  return instance.post('/hwperipheral/paramSetting', { ...data });
}

/**
 * 设备模式设置
 * @param {{sn: string,deviceType: string, requestData: {workModel: 0|1|2, windSpeed?:0|1|2|3|4|5}}} data
 * @returns
 */
export function deviceModeSetting(data) {
  return instance.post('/hwperipheral/deviceModeSetting', { ...data });
}

/**
 * 开关控制
 * @param {{ sn: string, deviceType: string, currState: 0|1|2|3|127, mobileState: 0|1}} params
 * @returns {Promise<any>}
 */
export function setSwitch(params) {
  return instance.get('/hwperipheral/modCtrlSetting', { params });
}

/**
 * 设置数据发送间隔
 * @param {{ sn: string, deviceType: string, currInterval: number}} params
 * @returns {Promise<any>}
 */
export function setNotifyInterval(params) {
  return instance.get('/hwperipheral/notifyIntervalSetting', { params });
}

/**
 * 重置wifi
 * @param {{sn: String, deviceType: String}} data
 */
export function resetWifi(data) {
  return instance.post('/hwperipheral/resetWifi', { ...data });
}

/**
 * ac1000参数设置
 * @param {Object} data
 * @param {string} data.sn 设备序列号
 * @param {0|1|2} data.code 0: 自动模式 1: 睡眠模式 2: 最爱模式
 * @param {1|2|3|4|5|6} data.windSpeed 1~6档
 * @param {0|1} data.disInfect 0: 关 1: 开
 * @returns {Promise<any>}
 */
export function setAC1000DeviceMode({ sn, code, windSpeed, disInfect }) {
  return instance.post('/hwperipheral/setAc1000DeviceMode', { sn, code, windSpeed, disInfect });
}

/**
 * 获取核素报警配置
 * @param {{ sn: string; deviceType: string }} params
 * @returns {{[key: string]: string}} -example {0: '0,0,23,44,55'}
 */
export function getNuclideAlarmConfig(params) {
  return instance.get('/hwperipheral/getNuclideAlarmConfig', { params });
}

/**
 * 设置核素报警配置
 * @param {Object} param
 * @param {string} param.sn
 * @param {string} param.deviceType
 * @param {Object} param.requestData
 * @param {string} param.requestData.setNuclideAlarmConfig -example {0: '0,0,23,44,55'}
 */
export function setNuclideAlarmConfig({ sn, deviceType, requestData }) {
  return instance.post('/hwperipheral/nuclideAlarmConfigSetting', {
    sn,
    deviceType,
    requestData
  });
}

/**
 * 获取合并报警信息
 * @param {Object} data
 * @param {string} data.alarmGroupId - 报警组ID
 * @param {number} data.offset - 页码
 * @param {number} data.limit - 每页条数
 * @returns
 */
export function getMergeAlarm(data) {
  return instance.post('/devicedata/getMergeAlarm', data);
}

/**
 * 退出合并报警
 * @param {Object} data
 * @param {string} data.alarmGroupId - 报警组ID
 * @param {string} data.id - 信息ID
 * @returns
 */
export function qiutMergeAlarm(data) {
  return instance.post('/devicedata/quitMergeAlarm', data);
}

/**
 * 获取611设备报警阈值信息
 * @param {{ sn: string; sensorSeq: number }} data
 */
export function get611DeviceAlarmThresholdInfo(data) {
  return instance.post('/devicecontrol/getAlarmThresh', { sn: data.sn, sensorSeq: data.sensorSeq });
}

/**
 * 设置611设备报警阈值信息
 */
export function set611DeviceAlarmThresholdInfo(data) {
  return instance.post('/devicecontrol/saveAlarmThresh', { ...data });
}

/**
 * 获取cd602算法参数
 * @param {string} sn
 * @returns
 */
export function getCD602AlgoParams(sn) {
  return instance.post('/cd602-devicedata/getAlgoParam', { sn });
}

/**
 * 设置cd602算法参数
 * @param {import('types/api/cd602.d.ts').ICDnumberAlgoParams} data
 * @returns
 */
export function setCD602AlgoParams(data) {
  return instance.post('/cd602-devicedata/setAlgoParam', { ...data });
}

/**
 * @typedef {Object} ICD602AlgoConfig
 * @property {number} s1Th - sensor11阈值
 * @property {number} s2Th - sensor22阈值
 * @property {number} zeroResetOffset - 零点偏移更新时间
 * @property {number} minimumAlarmTime - 报警持续时间
 * @property {number} stableTime - 稳定时间
 * @property {number} alarmBuffer - 报警缓冲时间
 * @property {number} dataBuffer - 数据比较缓冲时间
 * @property {number} ratioLowTh - 通道比值下限
 * @property {number} ratioHighTh - 通道比值上限
 */

/**
 * 获取cd602算法配置
 * @param {string} sn
 * @returns {Promise<import('types/api').TResult<ICD602AlgoConfig>>>}
 */
export function getCD602AlgoConfig(sn) {
  return instance.post('/cd602-devicedata/getAlgoConfig', { sn });
}

/**
 * 设置cd602算法配置
 * @param {ICD602AlgoConfig} data
 * @returns {Promise<any>}
 */
export function setCD602AlgoConfig(data) {
  return instance.post('/cd602-devicedata/setAlgoConfig', { ...data });
}

/**
 * 获取cd602设备参数
 * @param {{sn: string}} data
 * @returns
 */
export function getCD602DeviceParams(data) {
  return instance.post('/cd602-devicedata/getParam', { ...data });
}

/**
 * 设置cd602设备参数
 * @param {Object} data
 * @param {string} data.sn - 设备序列号
 * @param {0|1|2|3|4} data.alarmMode -  报警方式：0-无；1-灯；2-声音；3-振动；4-灯+声音+振动
 * @param {0|1|2} data.fanStatus - 风扇状态：0-停止；1-开启；2-故障
 * @param {0|1} data.workMode - 0-巡检模式；1-实时模式
 * @returns
 */
export function setCD602DeviceParams(data) {
  return instance.post('/cd602-devicedata/setParam', { ...data });
}

/**
 *
 * @typedef {Object} IFR01DeviceInfoItemValue
 * @property {number} itemCode - 项目代码
 * @property {string} itemId - 项目ID
 * @property {string} itemName - 项目名称
 * @property {string} itemValue - 项目值
 * @property {string} oldItemValue - 旧项目值
 * @property {string} sn - 序列号
 * @property {number} itemType - 项目类型
 * @property {number} itemLen - 项目长度
 * @property {number} defaultValue - 默认值
 */

/**
 * @param {Object} data
 * @param {number} data.alarmState - 报警状态
 * @param {number} data.autoReset - 自动重置
 * @param {number} data.autoResetTime - 自动重置时间
 * @param {number} data.autoSendAlarm - 自动发送报警
 * @param {number} data.autoSendAlarmCount - 自动发送报警次数
 * @param {number} data.autoSendAlarmInterval - 自动发送报警间隔
 * @param {number} data.baudRate - 波特率
 * @param {Array<IFR01DeviceInfoItemValue>} data.fr01DeviceInfoItemValueList - 设备信息项列表
 * @param {number} data.printFlag - 打印标志
 * @param {number} data.sensitivity - 灵敏度
 * @param {string} data.sn - 设备序列号
 * @param {number} data.stationNumber - 站点编号
 * @returns {Promise<{code: number, data: Object, message: string}>} 返回接口标准数据结构
 */
export function getFR01DeviceData(data) {
  return instance.post('/fr01-devicedata/queryParams', { ...data }, { disableDefTips: true });
}

/**
 * 修改FR01设备参数
 * @param {Object} data
 * @param {number} data.alarmState - 报警状态
 * @param {number} data.autoReset - 自动重置
 * @param {number} data.autoResetTime - 自动重置时间
 * @param {number} data.autoSendAlarm - 自动发送报警
 * @param {number} data.autoSendAlarmCount - 自动发送报警次数
 * @param {number} data.autoSendAlarmInterval - 自动发送报警间隔
 * @param {number} data.baudRate - 波特率
 * @param {Array<IFR01DeviceInfoItemValue>} data.fr01DeviceInfoItemValueList - 设备信息项列表
 * @param {number} data.printFlag - 打印标志
 * @param {number} data.sensitivity - 灵敏度
 * @param {string} data.sn - 设备序列号
 * @param {number} data.stationNumber - 站点编号
 * @returns {Promise<{code: number, data: Object, message: string}>} 返回接口标准数据结构
 */
export function setFR01DeviceParams(data) {
  return instance.post('/fr01-devicedata/updateParams', { ...data });
}

/**
 * 获取zx27设备参数
 * @param {{sn: string}} data
 * @returns {Promise<any>}
 */
export function getZX27DeviceParams(data) {
  return instance.post('/zx27-devicedata/getParam', { ...data }, { disableDefTips: true });
}

/**
 * 设置zx27设备参数
 * @param {Object} data
 * @param {string} data.sn - 设备序列号
 * @param {0|1|2|3|4} data.alarmMode -  报警方式：0-无；1-灯；2-声音；4-灯+声音+振动
 * @param {0|1|2} data.pumpStatus - 风扇状态：0-停止；1-开启；2-故障
 * @param {0|1} data.alarmEn - 屏蔽报警模式： 0-正常 1-屏蔽
 * @param {number} data.cottonTransTime - 单位秒
 * @returns {Promise<any>}
 */
export function setZX27DeviceParams(data) {
  return instance.post('/zx27-devicedata/setParam', { ...data });
}

/**
 * 获取zx27算法参数
 * @param {string} sn
 * @returns {Promise<any>}
 */
export function getZX27AlgoParams(sn) {
  return instance.post('/zx27-devicedata/getAlgoParam', { sn }, { disableDefTips: true });
}

/**
 * 设置zx27算法参数
 * @param {Object} data
 * @param {string} data.sn - 设备序列号
 * @returns {Promise<any>}
 */
export function setZX27AlgoParams(data) {
  return instance.post('/zx27-devicedata/setAlgoParam', { ...data });
}

/**
 * 获取MN606传感器报警阈值
 * @param {string} sn - 设备序列号
 * @returns {Promise<any>}
 */
export function getMN606SensroAlarmThresh(sn) {
  return instance.get('/devicedata/getSensorAlarmThresh', { params: { sn } });
}

/**
 * 设置MN606传感器报警阈值

 * @param {Object} data - 设备参数对象
 * @param {string} data.sn - 设备序列号
 * @param {number} data.sensorseg - 传感器段数组
 * @param {number} data.threshHi - 高报警
 * @param {number} data.threshLo - 低报警
 * @param {number} data.threshMac - 极大值
 * @param {number} data.threshstel - 预报警
 * @param {number} data.threshTwa - 八小时
 * @returns {Promise<any>}
 */
export function setMN606SensroAlarmThresh(data) {
  return instance.post('/devicedata/setSensorAlarmThresh', { ...data });
}

/**
 * 发送指示消息
 * @param {{ msgCode: string, sns: string[] }} data
 * @returns {Promise<any>}
 */
export function sendIndMsg(data) {
  return instance.post('/hwperipheral/sendIndMsg', { ...data });
}
